import CollapsedView from './CollapsedView.component';

export default CollapsedView;
